import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import type { InvestorChangeRequestDetails } from "../../../../../api/types/workflowTypes";
import MembersChangeRequestContributionHistory from "./MembersChangeRequestContributionHistory";
import { getRestrictedContentMessage } from "./membersChangeRequestHelper";
import MembersChangeSetsSection from "./MembersChangeSetsSection";

interface Props {
  changeRequestDetails: InvestorChangeRequestDetails;
}

const MembersChangeRequestDetailsSection = ({ changeRequestDetails }: Props) => {
  const restrictedContentMessage = getRestrictedContentMessage(changeRequestDetails);

  return (
    <Stack spacing={4}>
      <Typography variant="subtitle1">Request Details</Typography>

      {restrictedContentMessage && <Alert severity="warning">{restrictedContentMessage}</Alert>}

      {changeRequestDetails.allMemberUnitsWithdrawn && (
        <Alert severity="info">All requested changes were withdrawn. Nothing is pending approval.</Alert>
      )}

      {changeRequestDetails.workflowStatus === "InProgress" &&
        !changeRequestDetails.allMemberUnitsWithdrawn &&
        changeRequestDetails.memberContributors.length > 1 && (
          <Alert severity="info">
            <AlertTitle>Multiple investor contacts contributed to this request</AlertTitle>
            <Typography variant="inherit">
              What you approve below is the merged result of multiple submissions — see details in Contributors section
              below.
            </Typography>
          </Alert>
        )}

      <MembersChangeSetsSection
        changeSets={changeRequestDetails.changeSets}
        isPending={changeRequestDetails.workflowStatus === "InProgress"}
      />

      <MembersChangeRequestContributionHistory
        workflowId={changeRequestDetails.workflowId}
        contributors={changeRequestDetails.memberContributors}
      />
    </Stack>
  );
};

export default MembersChangeRequestDetailsSection;
